<div>
    <app-filter [tableType]="tableType" [config]="filterConfig" [visible]="false"></app-filter>
    <app-table [clickable]="true">
        <tr thead class="distinct">
            <app-table-header [width]="16" [text]="'FEATURES.MEASUREMENTS.COLUMNS.CAPTURED_DATE' | translate" />
            <app-table-header [width]="12" [text]="'FEATURES.MEASUREMENTS.COLUMNS.DURATION' | translate" />
        </tr>
        <ng-container tbody>
            <tr
                *ngFor="let item of measurements$ | async"
                (click)="showMeasurement(item.id)"
                [class.selected]="isSelected(item.id)"
                [class.loading]="isLoading && !isSelected(item.id)"
                [style.pointer-events]="isLoading ? 'none' : null"
            >
                <td>{{ item.capturedDate | dateTime: 'yyyy-MM-dd HH:mm' | replaceEmptyString }}</td>
                <td>{{ item.duration }}</td>
            </tr>
        </ng-container>
    </app-table>
</div>
